import { render, staticRenderFns } from "./ArticleReorders.vue?vue&type=template&id=1c05f6a9&"
import script from "./ArticleReorders.vue?vue&type=script&lang=js&"
export * from "./ArticleReorders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports